var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("Pagination", {
                    attrs: { numberOfDots: 5, numberOfVisitedDots: 3 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-wrapper" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.screening.eggheader)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.data.screening.eggtext) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "btn-group-toggle" }, [
                  _c(
                    "label",
                    {
                      staticClass: "btn btn-outline-secondary btn-lg radio-btn",
                      class: _vm.eggs.amount === "less_than_14" ? "active" : ""
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.eggs,
                            expression: "eggs"
                          }
                        ],
                        attrs: { type: "radio", autocomplete: "off" },
                        domProps: {
                          value: {
                            answer: "Mindre än 14 ägg per vecka",
                            amount: "less_than_14"
                          },
                          checked: _vm._q(_vm.eggs, {
                            answer: "Mindre än 14 ägg per vecka",
                            amount: "less_than_14"
                          })
                        },
                        on: {
                          change: function($event) {
                            _vm.eggs = {
                              answer: "Mindre än 14 ägg per vecka",
                              amount: "less_than_14"
                            }
                          }
                        }
                      }),
                      _vm._v(
                        "Mindre än 14 ägg per vecka (2 ägg/dag)\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "btn btn-outline-secondary btn-lg radio-btn",
                      class: _vm.eggs.amount === "more_than_14" ? "active" : ""
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.eggs,
                            expression: "eggs"
                          }
                        ],
                        attrs: { type: "radio", autocomplete: "off" },
                        domProps: {
                          value: {
                            answer: "Mer än 14 ägg per vecka",
                            amount: "more_than_14"
                          },
                          checked: _vm._q(_vm.eggs, {
                            answer: "Mer än 14 ägg per vecka",
                            amount: "more_than_14"
                          })
                        },
                        on: {
                          change: function($event) {
                            _vm.eggs = {
                              answer: "Mer än 14 ägg per vecka",
                              amount: "more_than_14"
                            }
                          }
                        }
                      }),
                      _vm._v("Mer än 14 ägg per vecka (2 ägg/dag)\n          ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: { disabled: Object.keys(_vm.eggs).length === 0 },
                    on: {
                      click: function($event) {
                        return _vm.verifyEggs()
                      }
                    }
                  },
                  [_vm._v("\n        Nästa\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("← Tillbaka")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("small", { staticClass: "pull-left" }, [
                  _vm._v("Välj ett alternativ för att gå vidare.")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Alert"),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb50e42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb50e42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScreeningEgg.vue
// module id = null
// module chunks = 